import api from './api';
import { USE_MOCK_DATA } from '../config/api';

/**
 * Get all members for a team
 */
export async function getTeamMembers(teamId) {
  console.log('[team-members-api] getTeamMembers called with teamId:', teamId);
  
  if (USE_MOCK_DATA) {
    console.log('[team-members-api] Using mock data');
    await new Promise(resolve => setTimeout(resolve, 300));
    return {
      members: [
        {
          playerId: 'player-1',
          teamId,
          name: 'John Doe',
          email: 'john@example.com',
          phone: '555-0101',
        },
        {
          playerId: 'player-2',
          teamId,
          name: 'Jane Smith',
          email: 'jane@example.com',
          phone: null,
        },
      ],
    };
  }

  console.log('[team-members-api] Making API call to:', `/teams/${teamId}/members`);
  const response = await api.get(`/teams/${teamId}/members`);
  console.log('[team-members-api] API response:', response);
  return response;
}

/**
 * Create a new team member
 */
export async function createTeamMember(teamId, memberData) {
  console.log('[team-members-api] createTeamMember called:', { teamId, memberData });
  
  if (USE_MOCK_DATA) {
    console.log('[team-members-api] Using mock data');
    await new Promise(resolve => setTimeout(resolve, 500));
    return {
      member: {
        playerId: `player-${Date.now()}`,
        teamId,
        ...memberData,
        createdAt: new Date().toISOString(),
      },
    };
  }

  console.log('[team-members-api] Making API call to:', `/teams/${teamId}/members`);
  const response = await api.post(`/teams/${teamId}/members`, memberData);
  console.log('[team-members-api] Create response:', response);
  return response;
}

/**
 * Update a team member
 */
export async function updateTeamMember(teamId, playerId, memberData) {
  if (USE_MOCK_DATA) {
    await new Promise(resolve => setTimeout(resolve, 500));
    return {
      member: {
        playerId,
        teamId,
        ...memberData,
        updatedAt: new Date().toISOString(),
      },
    };
  }

  return api.put(`/teams/${teamId}/members/${playerId}`, memberData);
}

/**
 * Delete a team member
 */
export async function deleteTeamMember(teamId, playerId) {
  if (USE_MOCK_DATA) {
    await new Promise(resolve => setTimeout(resolve, 300));
    return {};
  }

  return api.delete(`/teams/${teamId}/members/${playerId}`);
}

export default {
  getTeamMembers,
  createTeamMember,
  updateTeamMember,
  deleteTeamMember,
};
